<template>
  <v-btn
    class="navbarButton middle v-step-3"
    name="action"
    :disabled="!btnState"
    @click="launch()"
    :key="$route.path"
  >
    <v-icon>send</v-icon>
    Optimiser
  </v-btn>
</template>

<script>
import axios from 'axios';
// import router from "@/router"
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      myInterval: undefined,
    };
  },
  computed: {
    ...mapGetters({
      btnState: 'btnOptimValue',
    }),
  },
  methods: {
    checkMoteurAnswer() {
      const checkOptim =
        process.env.VUE_APP_BASE_URL + process.env.CHECK_OPTIMISATION;
      const user = this.$store.state.user;
      const self = this;
      axios({
        method: 'get',
        url: checkOptim,
        headers: {
          'Content-Type': 'application/json',
          user: user,
        },
      }).then(response => {
        if (response.status === 200) {
          self.$emit('hideSpinner');
          clearInterval(self.myInterval);
          self.myInterval = undefined;
          this.$toasted.show('Votre optimisation a été traitée', {
            type: 'success',
          });
        }
        if (response.status === 204) {
          self.$emit('hideSpinner');
          clearInterval(self.myInterval);
          self.myInterval = undefined;
          this.$toasted.show(
            "Votre optimisation n'a pas pu être traitée à cause d'erreurs, veuillez vous référer à l'email reçu pour en savoir plus.",
            { type: 'error' }
          );
          self.$emit('hideSpinner');
        }
      });
    },
    launch() {
      if (this.btnState === true) {
        if (
          confirm(
            "L'optimisation peut prendre plusieurs minutes. Voulez-vous lancer cette opération ?"
          )
        ) {
          this.$store.commit('setOptimizing', true);
          this.$toasted.show("Le solveur est en cours d'exécution", {
            type: 'info',
          });
          const launchOptim =
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_LAUNCH_OPTIMISATION;
          const user = this.$store.state.userInfos.email;
          const self = this;
          let httpContinueStatus = false;
          self.$store.commit('setAllButtons', {
            hideImport: true,
            hideBefore: false,
            hideOptim: true,
            hideAfter: true,
          });
          axios({
            method: 'get',
            url: launchOptim,
            headers: {
              'Content-Type': 'application/json',
              user: user,
            },
            timeout: 10800000,
          })
            .then(response => {
              if (response.status === 200) {
                this.$toasted.show("Le solveur s'est correctement exécuté", {
                  type: 'success',
                });
                self.$store.dispatch('setAllButtons', {
                  hideImport: false,
                  hideBefore: false,
                  hideOptim: true,
                  hideAfter: false,
                });
              } else if (response.status === 226) {
                httpContinueStatus = true;
              }
            })
            .catch(error => {
              self.$emit('hideSpinner');
              if (error.response.status === 423) {
                var date = new Date(error.response.data);
                this.$toasted.show(
                  "Une maintenance est en cours. Le lancement d'optimisation est temporairement désactivé. La fin de la maintenance est prévue le : " +
                    date.toLocaleString('fr-FR'),
                  { type: 'info' }
                );
              } else {
                self.$store.dispatch('setAllButtons', {
                  hideImport: false,
                  hideBefore: false,
                  hideOptim: true,
                  hideAfter: true,
                });
                this.$toasted.show(
                  "Votre optimisation n'a pas pu être traité, veuillez vous référer à l'email reçu pour en savoir plus.",
                  { type: 'error' }
                );
              }
            })
            .finally(() => {
              if (httpContinueStatus === false) {
                this.$store.dispatch('fetchUserInfos').then(() => {
                  const userInfos = this.$store.state.userInfos;
                  let path = null;

                  if (userInfos.pageAccueil === true) {
                    path = '/accueil';
                  } else if (userInfos.pageAvant === true) {
                    path = '/vision-globale';
                  } else if (userInfos.pageApres === true) {
                    path = '/optimisation';
                  } else {
                    path = '/accueil';
                  }
                  this.$router.push({ path: path });
                });
              }
            });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
